import { useState } from 'react';
import api from '../services/api.js';

export function useUpload() {
  const [uploading, setUploading] = useState(false);

  async function uploadFile(file) {
    if (!file) return null;
    const form = new FormData();
    form.append('file', file);
    setUploading(true);
    try {
      const { data } = await api.post('/v1/uploads/image', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (!data.success) throw new Error(data.message || 'Error de subida');
      return data.data.path;
    } finally {
      setUploading(false);
    }
  }

  async function uploadDocument(file) {
    if (!file) return null;
    const form = new FormData();
    form.append('file', file);
    setUploading(true);
    try {
      const { data } = await api.post('/v1/uploads/document', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (!data.success) throw new Error(data.message || 'Error de subida');
      return data.data.path;
    } finally {
      setUploading(false);
    }
  }

  return { uploadFile, uploadDocument, uploading };
}
